import { useTranslation } from 'react-i18next';
import { useAccount } from '../account/accountStore.ts';
import { useFlag } from '../meta/liveStore.ts';
import { onlineAvailable } from '../online/onlineConnection.ts';
import { Badge, MenuTile, ScreenFrame, type IconName } from '../ui/index.ts';
import styles from './Play.module.css';

/** `to` is where the mode starts; modes without a screen yet point at the "not open" page. */
const MODES = [
  { id: 'quick', icon: 'bolt', to: '/soon/quick' },
  { id: 'ranked', icon: 'star', to: '/soon/ranked' },
  { id: 'private', icon: 'key', to: '/soon/private' },
  { id: 'solo', icon: 'profile', to: '/play/solo' },
  { id: 'training', icon: 'target', to: '/play/training' },
  { id: 'daily', icon: 'calendar', to: '/soon/daily' },
  { id: 'tutorial', icon: 'book', to: '/play/tutorial' },
] as const satisfies readonly { id: string; icon: IconName; to: string }[];

export function Play() {
  const { t } = useTranslation('play');
  const { t: tc } = useTranslation('common');
  const accountAvailable = useAccount((s) => s.setup.available);
  const onlineOpen = accountAvailable && onlineAvailable();
  const dailyOn = useFlag('daily');
  return (
    <ScreenFrame title={t('title')} backTo="/" tone="blueprint">
      <ul className={styles['list']}>
        {MODES.map((mode, i) => {
          // Quick match and private rooms are open when there is an account and a server to go to.
          const to =
            onlineOpen && (mode.id === 'quick' || mode.id === 'private' || mode.id === 'ranked')
              ? '/online'
              : mode.id === 'daily' && onlineOpen && dailyOn
                ? '/daily'
                : mode.to;
          return (
            <li key={mode.id}>
              <MenuTile
                index={i}
                to={to}
                icon={mode.icon}
                title={t(`modes.${mode.id}.name`)}
                hint={t(`modes.${mode.id}.desc`)}
                badge={to.startsWith('/soon') ? <Badge tone="amber">{tc('soon')}</Badge> : null}
              />
            </li>
          );
        })}
      </ul>
    </ScreenFrame>
  );
}
